import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { useAppStateSelector } from '@src/providers/AppStateProvider/AppStateProviderHooks';
import type { AppState } from '@src/providers/AppStateProvider/types';

export interface CoinMetricsCredentialsState {
  apiKey: string | null;
}

const initialState: CoinMetricsCredentialsState = {
  apiKey: null,
};

const coinMetricsCredentialsSlice = createSlice({
  name: 'coinMetricsCredentials',
  initialState,
  reducers: {
    setCoinMetricsApiKey: (state, action: PayloadAction<string | null>) => {
      state.apiKey = action.payload;
    },
  },
});

export const { setCoinMetricsApiKey } = coinMetricsCredentialsSlice.actions;
export const coinMetricsCredentialsReducer = coinMetricsCredentialsSlice.reducer;

export const selectCoinMetricsCredentials = (state: AppState): CoinMetricsCredentialsState =>
  state.coinMetricsCredentials;
export const selectCoinMetricsApiKey = (state: AppState): string | null => state.coinMetricsCredentials.apiKey;

/**
 * Returns the CoinMetrics Pro API key from Redux.
 *
 * Use the returned value in the `skip` guard for pro-tier endpoint hooks:
 * @example
 * const apiKey = useCoinMetricsApiKey();
 * const { data } = useSomeProEndpointQuery(params, { skip: !apiKey });
 *
 * Community-tier endpoint hooks need no skip guard — their base URL is a static constant.
 */
export const useCoinMetricsApiKey = () => useAppStateSelector(selectCoinMetricsApiKey);
